import { create } from "zustand";


interface IDrawer {
    open: boolean;
    setOpen: (val: boolean) => void;
    title: string;
    isFirstPage: boolean;
    popPage: () => void;
    pages: JSX.Element[];
    pageTitles: string[];
    addPage: (page: JSX.Element, title: string) => void;
}

export const useDrawerStore = create<IDrawer>((set, get) => ({
    open: false,
    setOpen: (val: boolean) => {
        set((state: IDrawer) => ({ ...state, open: val }));
    },
    title: '',
    pageTitles: [],
    isFirstPage: false,
    popPage: () => {
        const firstPage = get().pages.length === 1;

        if (firstPage) {
            set((state: IDrawer) => ({ ...state, open: false, pages: [], title: '', pageTitles: [], isFirstPage: true }));
            return;
        }
        const pageTitles = get().pageTitles;
        const title = pageTitles[pageTitles.length - 2];
        pageTitles.pop();
        set((state: IDrawer) => ({ ...state, pages: state.pages.slice(0, -1), title, pageTitles, isFirstPage: firstPage }));
    },
    pages: [],
    addPage: (page: JSX.Element, title: string) => {
        get().pageTitles.push(title);
        const pageTitles = get().pageTitles;
        set((state: IDrawer) => ({ ...state, open: true, pages: [...state.pages, page], title, pageTitles, isFirstPage: state.pages.length === 0 }));
    }
 }));